import { Box, Heading, Text, Image,HStack, Flex, SimpleGrid } from '@chakra-ui/react';
import PublicLayout from "./Layouts/PublicLayout"
import RefundPolicy from "../../Components/RefundPolicy"

const B2CRefundPolicy = () => (
  <PublicLayout>
      <Box p={4}>
<RefundPolicy />
      </Box>
  </PublicLayout>
);

export default B2CRefundPolicy;